import React, { useContext } from 'react';
import { I18nReactContext } from '../../../../../contexts/I18nContext';
import './TemplateItem.scss';

/**
 * TemplateItem Component
 * 
 * This component displays a single template item with a thumbnail and information.
 * It's designed to be reusable across different parts of the application.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.template - Template object to display
 * @param {string} props.direction - Text direction ('ltr' or 'rtl')
 * @param {Function} props.onSelect - Callback function called when the template is selected
 * @returns {JSX.Element} The rendered TemplateItem component
 */
export const TemplateItem = ({ template, direction, onSelect }) => {
  // Get i18n context for translations
  const { i18n } = useContext(I18nReactContext);

  return (
    <div 
      className="TemplateItem"
      onClick={() => onSelect(template)}
      role="button"
      aria-label={i18n.translate('weezbeeCourse.templateBank.selectTemplate', { context: { templateName: i18n.translate(template.nameKey) } })}
    >
      {/* Visual representation of the template layout */}
      <div className={`template-thumbnail ${template.thumbnail} ${direction === 'rtl' ? 'rtl' : ''}`}>
        {/* These divs represent the visual elements in the template */}
        <div className="thumbnail-logo" aria-hidden="true"></div>
        <div className="thumbnail-title" aria-hidden="true"></div>
        <div className="thumbnail-image" aria-hidden="true"></div>
        <div className="thumbnail-text" aria-hidden="true"></div>
      </div>

      {/* Template name and description */}
      <div className="template-info">
        <h3>{i18n.translate(template.nameKey)}</h3>
        <p>{i18n.translate(template.descriptionKey)}</p>
      </div>
    </div>
  );
};